export const openEndedActivityMaterialContentStyles = `
  .qab-record-box {
    width: 320px;
    cursor: pointer;
    transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1);
  }
  .qab-opacity-100 {
    opacity: 1;
  }
  .qab-opacity-0 {
    opacity: 0;
  }
  .qab-w-full {
    width: 100%;
  }
  .qab-status-box {
    border-width: 1px;
    border-style: solid;
    border-radius: var(--rad-catchup-xlarge);
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
  .qab-status-box-dark-blue {
    border-color: var(--catchup-dark-blue);
  }
  .qab-status-box-orange {
    border-color: var(--catchup-orange);
  }
  .qab-status-box-red {
    border-color: var(--catchup-red);
  }
  .qab-status-text {
    padding-left: 1rem;
    padding-right: 1rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    text-align: center;
  }
  .qab-status-text-2xl {
    font-size: var(--fs-2xl);
    color: var(--catchup-dark-blue);
  }
  .qab-status-text-xl-orange {
    font-size: var(--fs-xl);
    color: var(--catchup-orange);
  }
  .qab-status-text-xl-red {
    font-size: var(--fs-xl);
    color: var(--catchup-red);
  }
  .qab-status-text-xl-dark-blue {
    font-size: var(--fs-xl);
    color: var(--catchup-dark-blue);
  }
  .qab-col-center {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .qab-mt-4 {
    margin-top: 1rem;
  }
  .qab-row-gap-2 {
    display: flex;
    flex-direction: row;
    column-gap: 0.5rem;
  }
  .qab-row-center-gap-2 {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    column-gap: 0.5rem;
  }
  .qab-row-center-gap-2-no-justify {
    display: flex;
    flex-direction: row;
    align-items: center;
    column-gap: 0.5rem;
  }
  .qab-mt-4-block {
    margin-top: 1rem;
  }
  .qab-flex-1 {
    flex: 1 1 0%;
  }
  .qab-col-center-my-5 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 1.25rem;
    margin-bottom: 1.25rem;
  }
  .qab-col-gap-y-2 {
    display: flex;
    flex-direction: column;
  }
  .qab-col-gap-y-2 > * + * {
    margin-top: 0.5rem;
  }
  .qab-audio-box {
    height: 56px;
  }
  .qab-audio {
    height: 100%;
    width: 100%;
    border-radius: var(--rad-catchup-xlarge);
  }
  .qab-media-img {
    width: 100%;
    border-radius: var(--rad-catchup-xlarge);
    max-height: 50vh;
    object-fit: contain;
  }
  .qab-media-video {
    width: 100%;
    border-radius: var(--rad-catchup-xlarge);
    max-height: 50vh;
  }
  .qab-upload-row {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    column-gap: 1rem;
    flex-wrap: wrap;
  }
  .qab-upload-option {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    column-gap: 0.5rem;
  }
  .qab-hidden {
    display: none;
  }
  .qab-modal-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  }
  .qab-modal-half {
    width: 50%;
  }
  .qab-my-10 {
    margin-top: 2.5rem;
    margin-bottom: 2.5rem;
  }
  .qab-instructions-pad {
    padding-left: 1rem;
    padding-right: 1rem;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
  .qab-instructions-list {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .qab-instructions-list > * + * {
    margin-top: 0.25rem;
  }
  .qab-prompt {
    display: none;
  }
  .qab-prompt-text {
    font-weight: 600;
    font-size: var(--fs-xl);
    opacity: 0.6;
  }
  .qab-divider {
    display: none;
  }
  @media (min-width: 768px) {
    .qab-prompt {
      display: block;
    }
    .qab-divider {
      display: contents;
    }
  }
`;
